import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {}
});

export default (state = getInitialState(), action) => {
    let newById;
    switch (action.type) {
        case ACTIONS.GET_MANY_SETTINGS: {
            newById = action.payload.settings.reduce((prev, setting) => {
                prev[setting._id] = setting;
                return prev;
            }, {});

            return {
                ...state,
                byId: newById
            };
        }

        case ACTIONS.GET_SETTING:
        case ACTIONS.PUT_SETTING_SUCCESS:
        case ACTIONS.POST_SETTING_SUCCESS: {
            const { body } = action.payload;
            newById = Object.assign({}, state.byId, {
                [body._id]: body
            });

            return Object.assign({}, state, {
                byId: newById,
                currentId: body._id
            });
        }

        default:
            return state;
    }
};
